import React, {useEffect, useRef, useState} from 'react';

interface CountdownTimerProps {
    expireTime: Date;
    className?: string;
    onExpire?: () => void;
}

const remainingSeconds = (expiresAt: number): number =>
    Math.max(0, Math.floor((expiresAt - Date.now()) / 1000));

const CountdownTimer = ({expireTime, className, onExpire}: CountdownTimerProps): JSX.Element => {
    const expiresAt = expireTime.getTime();
    const [timeLeft, setTimeLeft] = useState(() => remainingSeconds(expiresAt));
    const onExpireRef = useRef(onExpire);
    const notifiedExpiry = useRef<number | undefined>();
    onExpireRef.current = onExpire;

    useEffect(() => {
        const tick = () => {
            const remaining = remainingSeconds(expiresAt);
            setTimeLeft(remaining);
            if (remaining === 0 && notifiedExpiry.current !== expiresAt) {
                notifiedExpiry.current = expiresAt;
                onExpireRef.current?.();
            }
            return remaining;
        };

        if (tick() === 0) {
            return;
        }
        const interval = window.setInterval(() => {
            if (tick() === 0) {
                window.clearInterval(interval);
            }
        }, 1000);
        return () => window.clearInterval(interval);
    }, [expiresAt]);

    const pad = (value: number): string => String(value).padStart(2, '0');
    const hours = Math.floor(timeLeft / 3600);
    const minutes = Math.floor((timeLeft % 3600) / 60);
    const seconds = timeLeft % 60;

    return <div className={className}>{pad(hours)}:{pad(minutes)}:{pad(seconds)}</div>;
};

export default CountdownTimer;

